var Yt = Object.defineProperty;
var Qt = (t, e, r) => e in t ? Yt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var se = (t, e, r) => Qt(t, typeof e != "symbol" ? e + "" : e, r);
var Xt = Object.create, gt = Object.defineProperty, er = Object.getOwnPropertyDescriptor, _t = Object.getOwnPropertyNames, tr = Object.getPrototypeOf, rr = Object.prototype.hasOwnProperty, Z = (t, e) => function() {
  return e || (0, t[_t(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, nr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (var s = _t(e), i = 0, a = s.length, o; i < a; i++)
    o = s[i], !rr.call(t, o) && o !== r && gt(t, o, {
      get: ((c) => e[c]).bind(null, o),
      enumerable: !(n = er(e, o)) || n.enumerable
    });
  return t;
}, P = (t, e, r) => (r = t != null ? Xt(tr(t)) : {}, nr(gt(r, "default", {
  value: t,
  enumerable: !0
}), t)), bt = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js"(t, e) {
  function r(n) {
    "@babel/helpers - typeof";
    return e.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, r(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), sr = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js"(t, e) {
  var r = bt().default;
  function n(s, i) {
    if (r(s) != "object" || !s) return s;
    var a = s[Symbol.toPrimitive];
    if (a !== void 0) {
      var o = a.call(s, i || "default");
      if (r(o) != "object") return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(s);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), ir = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js"(t, e) {
  var r = bt().default, n = sr();
  function s(i) {
    var a = n(i, "string");
    return r(a) == "symbol" ? a : a + "";
  }
  e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), J = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js"(t, e) {
  var r = ir();
  function n(s, i, a) {
    return (i = r(i)) in s ? Object.defineProperty(s, i, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : s[i] = a, s;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), R = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js"(t, e) {
  var r = J();
  function n(i, a) {
    var o = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var c = Object.getOwnPropertySymbols(i);
      a && (c = c.filter(function(u) {
        return Object.getOwnPropertyDescriptor(i, u).enumerable;
      })), o.push.apply(o, c);
    }
    return o;
  }
  function s(i) {
    for (var a = 1; a < arguments.length; a++) {
      var o = arguments[a] != null ? arguments[a] : {};
      a % 2 ? n(Object(o), !0).forEach(function(c) {
        r(i, c, o[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function(c) {
        Object.defineProperty(i, c, Object.getOwnPropertyDescriptor(o, c));
      });
    }
    return i;
  }
  e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
} });
function je(t) {
  const e = {
    subscribe(r) {
      let n = null, s = !1, i = !1, a = !1;
      function o() {
        if (n === null) {
          a = !0;
          return;
        }
        i || (i = !0, typeof n == "function" ? n() : n && n.unsubscribe());
      }
      return n = t({
        next(c) {
          var u;
          s || (u = r.next) === null || u === void 0 || u.call(r, c);
        },
        error(c) {
          var u;
          s || (s = !0, (u = r.error) === null || u === void 0 || u.call(r, c), o());
        },
        complete() {
          var c;
          s || (s = !0, (c = r.complete) === null || c === void 0 || c.call(r), o());
        }
      }), a && o(), { unsubscribe: o };
    },
    pipe(...r) {
      return r.reduce(ar, e);
    }
  };
  return e;
}
function ar(t, e) {
  return e(t);
}
function or(t) {
  const e = new AbortController();
  return new Promise((n, s) => {
    let i = !1;
    function a() {
      i || (i = !0, o.unsubscribe());
    }
    e.signal.addEventListener("abort", () => {
      s(e.signal.reason);
    });
    const o = t.subscribe({
      next(c) {
        i = !0, n(c), a();
      },
      error(c) {
        s(c);
      },
      complete() {
        e.abort(), a();
      }
    });
  });
}
function cr(t) {
  return (e) => {
    let r = 0, n = null;
    const s = [];
    function i() {
      n || (n = e.subscribe({
        next(o) {
          for (const u of s) {
            var c;
            (c = u.next) === null || c === void 0 || c.call(u, o);
          }
        },
        error(o) {
          for (const u of s) {
            var c;
            (c = u.error) === null || c === void 0 || c.call(u, o);
          }
        },
        complete() {
          for (const c of s) {
            var o;
            (o = c.complete) === null || o === void 0 || o.call(c);
          }
        }
      }));
    }
    function a() {
      if (r === 0 && n) {
        const o = n;
        n = null, o.unsubscribe();
      }
    }
    return je((o) => (r++, s.push(o), i(), { unsubscribe() {
      r--, a();
      const c = s.findIndex((u) => u === o);
      c > -1 && s.splice(c, 1);
    } }));
  };
}
function ur(t) {
  let e = t;
  const r = [], n = (a) => {
    e !== void 0 && a.next(e), r.push(a);
  }, s = (a) => {
    r.splice(r.indexOf(a), 1);
  }, i = je((a) => (n(a), () => {
    s(a);
  }));
  return i.next = (a) => {
    if (e !== a) {
      e = a;
      for (const o of r) o.next(a);
    }
  }, i.get = () => e, i;
}
function lr(t) {
  return je((e) => {
    function r(s = 0, i = t.op) {
      const a = t.links[s];
      if (!a) throw new Error("No more links to execute - did you forget to add an ending link?");
      return a({
        op: i,
        next(c) {
          return r(s + 1, c);
        }
      });
    }
    return r().subscribe(e);
  });
}
function ce(t) {
  return !!t && !Array.isArray(t) && typeof t == "object";
}
var dr = Object.create, xt = Object.defineProperty, fr = Object.getOwnPropertyDescriptor, wt = Object.getOwnPropertyNames, hr = Object.getPrototypeOf, pr = Object.prototype.hasOwnProperty, pe = (t, e) => function() {
  return e || (0, t[wt(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, mr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (var s = wt(e), i = 0, a = s.length, o; i < a; i++)
    o = s[i], !pr.call(t, o) && o !== r && xt(t, o, {
      get: ((c) => e[c]).bind(null, o),
      enumerable: !(n = fr(e, o)) || n.enumerable
    });
  return t;
}, Ee = (t, e, r) => (r = t != null ? dr(hr(t)) : {}, mr(xt(r, "default", {
  value: t,
  enumerable: !0
}), t));
const kt = () => {
}, Je = (t) => {
  Object.freeze && Object.freeze(t);
};
function Ot(t, e, r) {
  var n;
  const s = e.join(".");
  return (n = r[s]) !== null && n !== void 0 || (r[s] = new Proxy(kt, {
    get(i, a) {
      if (!(typeof a != "string" || a === "then"))
        return Ot(t, [...e, a], r);
    },
    apply(i, a, o) {
      const c = e[e.length - 1];
      let u = {
        args: o,
        path: e
      };
      return c === "call" ? u = {
        args: o.length >= 2 ? [o[1]] : [],
        path: e.slice(0, -1)
      } : c === "apply" && (u = {
        args: o.length >= 2 ? o[1] : [],
        path: e.slice(0, -1)
      }), Je(u.args), Je(u.path), t(u);
    }
  })), r[s];
}
const yr = (t) => Ot(t, [], /* @__PURE__ */ Object.create(null)), vr = (t) => new Proxy(kt, { get(e, r) {
  if (r !== "then")
    return t(r);
} });
var St = pe({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/typeof.js"(t, e) {
  function r(n) {
    "@babel/helpers - typeof";
    return e.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, r(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), gr = pe({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPrimitive.js"(t, e) {
  var r = St().default;
  function n(s, i) {
    if (r(s) != "object" || !s) return s;
    var a = s[Symbol.toPrimitive];
    if (a !== void 0) {
      var o = a.call(s, i || "default");
      if (r(o) != "object") return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(s);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), _r = pe({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/toPropertyKey.js"(t, e) {
  var r = St().default, n = gr();
  function s(i) {
    var a = n(i, "string");
    return r(a) == "symbol" ? a : a + "";
  }
  e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), Pt = pe({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/defineProperty.js"(t, e) {
  var r = _r();
  function n(s, i, a) {
    return (i = r(i)) in s ? Object.defineProperty(s, i, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : s[i] = a, s;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), We = pe({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/objectSpread2.js"(t, e) {
  var r = Pt();
  function n(i, a) {
    var o = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var c = Object.getOwnPropertySymbols(i);
      a && (c = c.filter(function(u) {
        return Object.getOwnPropertyDescriptor(i, u).enumerable;
      })), o.push.apply(o, c);
    }
    return o;
  }
  function s(i) {
    for (var a = 1; a < arguments.length; a++) {
      var o = arguments[a] != null ? arguments[a] : {};
      a % 2 ? n(Object(o), !0).forEach(function(c) {
        r(i, c, o[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function(c) {
        Object.defineProperty(i, c, Object.getOwnPropertyDescriptor(o, c));
      });
    }
    return i;
  }
  e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
} });
Ee(We());
Ee(Pt());
var ye = Ee(We());
function br(t, e) {
  if ("error" in t) {
    const n = e.deserialize(t.error);
    return {
      ok: !1,
      error: (0, ye.default)((0, ye.default)({}, t), {}, { error: n })
    };
  }
  return {
    ok: !0,
    result: (0, ye.default)((0, ye.default)({}, t.result), (!t.result.type || t.result.type === "data") && {
      type: "data",
      data: e.deserialize(t.result.data)
    })
  };
}
var Ce = class extends Error {
  constructor() {
    super("Unable to transform response from server");
  }
};
function xr(t, e) {
  let r;
  try {
    r = br(t, e);
  } catch {
    throw new Ce();
  }
  if (!r.ok && (!ce(r.error.error) || typeof r.error.error.code != "number")) throw new Ce();
  if (r.ok && !ce(r.result)) throw new Ce();
  return r;
}
Ee(We());
var ve = P(J()), G = P(R());
function wr(t) {
  return t instanceof xe;
}
function kr(t) {
  return ce(t) && ce(t.error) && typeof t.error.code == "number" && typeof t.error.message == "string";
}
function Or(t, e) {
  return typeof t == "string" ? t : ce(t) && typeof t.message == "string" ? t.message : e;
}
var xe = class _e extends Error {
  constructor(e, r) {
    var n, s;
    const i = r == null ? void 0 : r.cause;
    super(e, { cause: i }), (0, ve.default)(this, "cause", void 0), (0, ve.default)(this, "shape", void 0), (0, ve.default)(this, "data", void 0), (0, ve.default)(this, "meta", void 0), this.meta = r == null ? void 0 : r.meta, this.cause = i, this.shape = r == null || (n = r.result) === null || n === void 0 ? void 0 : n.error, this.data = r == null || (s = r.result) === null || s === void 0 ? void 0 : s.error.data, this.name = "TRPCClientError", Object.setPrototypeOf(this, _e.prototype);
  }
  static from(e, r = {}) {
    const n = e;
    return wr(n) ? (r.meta && (n.meta = (0, G.default)((0, G.default)({}, n.meta), r.meta)), n) : kr(n) ? new _e(n.error.message, (0, G.default)((0, G.default)({}, r), {}, { result: n })) : new _e(Or(n, "Unknown error"), (0, G.default)((0, G.default)({}, r), {}, { cause: n }));
  }
};
function Sr(t) {
  const e = t;
  return e ? "input" in e ? e : {
    input: e,
    output: e
  } : {
    input: {
      serialize: (r) => r,
      deserialize: (r) => r
    },
    output: {
      serialize: (r) => r,
      deserialize: (r) => r
    }
  };
}
const Ke = (t) => typeof t == "function";
function Pr(t) {
  if (t) return t;
  if (typeof window < "u" && Ke(window.fetch)) return window.fetch;
  if (typeof globalThis < "u" && Ke(globalThis.fetch)) return globalThis.fetch;
  throw new Error("No fetch implementation found");
}
var ae = P(R());
function Tr(t) {
  return {
    url: t.url.toString(),
    fetch: t.fetch,
    transformer: Sr(t.transformer),
    methodOverride: t.methodOverride
  };
}
function jr(t) {
  const e = {};
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    e[r] = n;
  }
  return e;
}
const Er = {
  query: "GET",
  mutation: "POST",
  subscription: "PATCH"
};
function Tt(t) {
  return "input" in t ? t.transformer.input.serialize(t.input) : jr(t.inputs.map((e) => t.transformer.input.serialize(e)));
}
const jt = (t) => {
  const e = t.url.split("?");
  let n = e[0].replace(/\/$/, "") + "/" + t.path;
  const s = [];
  if (e[1] && s.push(e[1]), "inputs" in t && s.push("batch=1"), t.type === "query" || t.type === "subscription") {
    const i = Tt(t);
    i !== void 0 && t.methodOverride !== "POST" && s.push(`input=${encodeURIComponent(JSON.stringify(i))}`);
  }
  return s.length && (n += "?" + s.join("&")), n;
}, Ar = (t) => {
  if (t.type === "query" && t.methodOverride !== "POST") return;
  const e = Tt(t);
  return e !== void 0 ? JSON.stringify(e) : void 0;
}, Cr = (t) => Zr((0, ae.default)((0, ae.default)({}, t), {}, {
  contentTypeHeader: "application/json",
  getUrl: jt,
  getBody: Ar
}));
var Rr = class extends Error {
  constructor() {
    const t = "AbortError";
    super(t), this.name = t, this.message = t;
  }
};
const Ir = (t) => {
  var e;
  if (t != null && t.aborted)
    throw (e = t.throwIfAborted) === null || e === void 0 || e.call(t), typeof DOMException < "u" ? new DOMException("AbortError", "AbortError") : new Rr();
};
async function Nr(t) {
  var e;
  Ir(t.signal);
  const r = t.getUrl(t), n = t.getBody(t), { type: s } = t, i = await (async () => {
    const o = await t.headers();
    return Symbol.iterator in o ? Object.fromEntries(o) : o;
  })(), a = (0, ae.default)((0, ae.default)((0, ae.default)({}, t.contentTypeHeader ? { "content-type": t.contentTypeHeader } : {}), t.trpcAcceptHeader ? { "trpc-accept": t.trpcAcceptHeader } : void 0), i);
  return Pr(t.fetch)(r, {
    method: (e = t.methodOverride) !== null && e !== void 0 ? e : Er[s],
    signal: t.signal,
    body: n,
    headers: a
  });
}
async function Zr(t) {
  const e = {}, r = await Nr(t);
  e.response = r;
  const n = await r.json();
  return e.responseJSON = n, {
    json: n,
    meta: e
  };
}
P(R());
const Ge = () => {
  throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
function He(t) {
  let e = null, r = null;
  const n = () => {
    clearTimeout(r), r = null, e = null;
  };
  function s(o) {
    const c = [[]];
    let u = 0;
    for (; ; ) {
      const b = o[u];
      if (!b) break;
      const g = c[c.length - 1];
      if (b.aborted) {
        var f;
        (f = b.reject) === null || f === void 0 || f.call(b, new Error("Aborted")), u++;
        continue;
      }
      if (t.validate(g.concat(b).map((_) => _.key))) {
        g.push(b), u++;
        continue;
      }
      if (g.length === 0) {
        var m;
        (m = b.reject) === null || m === void 0 || m.call(b, new Error("Input is too big for a single dispatch")), u++;
        continue;
      }
      c.push([]);
    }
    return c;
  }
  function i() {
    const o = s(e);
    n();
    for (const c of o) {
      if (!c.length) continue;
      const u = { items: c };
      for (const m of c) m.batch = u;
      t.fetch(u.items.map((m) => m.key)).then(async (m) => {
        await Promise.all(m.map(async (g, S) => {
          const _ = u.items[S];
          try {
            var j;
            const C = await Promise.resolve(g);
            (j = _.resolve) === null || j === void 0 || j.call(_, C);
          } catch (C) {
            var K;
            (K = _.reject) === null || K === void 0 || K.call(_, C);
          }
          _.batch = null, _.reject = null, _.resolve = null;
        }));
        for (const g of u.items) {
          var b;
          (b = g.reject) === null || b === void 0 || b.call(g, new Error("Missing result")), g.batch = null;
        }
      }).catch((m) => {
        for (const g of u.items) {
          var b;
          (b = g.reject) === null || b === void 0 || b.call(g, m), g.batch = null;
        }
      });
    }
  }
  function a(o) {
    var c;
    const u = {
      aborted: !1,
      key: o,
      batch: null,
      resolve: Ge,
      reject: Ge
    }, f = new Promise((m, b) => {
      var g;
      u.reject = b, u.resolve = m, (g = e) !== null && g !== void 0 || (e = []), e.push(u);
    });
    return (c = r) !== null && c !== void 0 || (r = setTimeout(i)), f;
  }
  return { load: a };
}
function Mr(...t) {
  const e = new AbortController(), r = t.length;
  let n = 0;
  const s = () => {
    ++n === r && e.abort();
  };
  for (const i of t) i != null && i.aborted ? s() : i == null || i.addEventListener("abort", s, { once: !0 });
  return e.signal;
}
var ge = P(R());
function Vr(t) {
  var e, r;
  const n = Tr(t), s = (e = t.maxURLLength) !== null && e !== void 0 ? e : 1 / 0, i = (r = t.maxItems) !== null && r !== void 0 ? r : 1 / 0;
  return () => {
    const a = (f) => ({
      validate(m) {
        if (s === 1 / 0 && i === 1 / 0) return !0;
        if (m.length > i) return !1;
        const b = m.map((_) => _.path).join(","), g = m.map((_) => _.input);
        return jt((0, ge.default)((0, ge.default)({}, n), {}, {
          type: f,
          path: b,
          inputs: g,
          signal: null
        })).length <= s;
      },
      async fetch(m) {
        const b = m.map((C) => C.path).join(","), g = m.map((C) => C.input), S = Mr(...m.map((C) => C.signal)), _ = await Cr((0, ge.default)((0, ge.default)({}, n), {}, {
          path: b,
          inputs: g,
          type: f,
          headers() {
            return t.headers ? typeof t.headers == "function" ? t.headers({ opList: m }) : t.headers : {};
          },
          signal: S
        }));
        return (Array.isArray(_.json) ? _.json : m.map(() => _.json)).map((C) => ({
          meta: _.meta,
          json: C
        }));
      }
    }), o = He(a("query")), c = He(a("mutation")), u = {
      query: o,
      mutation: c
    };
    return ({ op: f }) => je((m) => {
      /* istanbul ignore if -- @preserve */
      if (f.type === "subscription") throw new Error("Subscriptions are unsupported by `httpLink` - use `httpSubscriptionLink` or `wsLink`");
      const g = u[f.type].load(f);
      let S;
      return g.then((_) => {
        S = _;
        const j = xr(_.json, n.transformer.output);
        if (!j.ok) {
          m.error(xe.from(j.error, { meta: _.meta }));
          return;
        }
        m.next({
          context: _.meta,
          result: j.result
        }), m.complete();
      }).catch((_) => {
        m.error(xe.from(_, { meta: S == null ? void 0 : S.meta }));
      }), () => {
      };
    });
  };
}
P(R());
const Et = (t, ...e) => typeof t == "function" ? t(...e) : t;
P(J());
function $r() {
  let t, e;
  return {
    promise: new Promise((n, s) => {
      t = n, e = s;
    }),
    resolve: t,
    reject: e
  };
}
async function Lr(t) {
  const e = await Et(t.url);
  if (!t.connectionParams) return e;
  const n = `${e.includes("?") ? "&" : "?"}connectionParams=1`;
  return e + n;
}
async function zr(t) {
  const e = {
    method: "connectionParams",
    data: await Et(t)
  };
  return JSON.stringify(e);
}
P(J());
var W = P(J());
function Dr(t) {
  const { promise: e, resolve: r, reject: n } = $r();
  return t.addEventListener("open", () => {
    t.removeEventListener("error", n), r();
  }), t.addEventListener("error", n), e;
}
function Ur(t, { intervalMs: e, pongTimeoutMs: r }) {
  let n, s;
  function i() {
    n = setTimeout(() => {
      t.send("PING"), s = setTimeout(() => {
        t.close();
      }, r);
    }, e);
  }
  function a() {
    clearTimeout(n), i();
  }
  function o() {
    clearTimeout(s), a();
  }
  t.addEventListener("open", i), t.addEventListener("message", ({ data: c }) => {
    clearTimeout(n), i(), c === "PONG" && o();
  }), t.addEventListener("close", () => {
    clearTimeout(n), clearTimeout(s);
  });
}
var qr = class Ze {
  constructor(e) {
    var r;
    if ((0, W.default)(this, "id", ++Ze.connectCount), (0, W.default)(this, "WebSocketPonyfill", void 0), (0, W.default)(this, "urlOptions", void 0), (0, W.default)(this, "keepAliveOpts", void 0), (0, W.default)(this, "wsObservable", ur(null)), (0, W.default)(this, "openPromise", null), this.WebSocketPonyfill = (r = e.WebSocketPonyfill) !== null && r !== void 0 ? r : WebSocket, !this.WebSocketPonyfill) throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
    this.urlOptions = e.urlOptions, this.keepAliveOpts = e.keepAlive;
  }
  get ws() {
    return this.wsObservable.get();
  }
  set ws(e) {
    this.wsObservable.next(e);
  }
  /**
  * Checks if the WebSocket connection is open and ready to communicate.
  */
  isOpen() {
    return !!this.ws && this.ws.readyState === this.WebSocketPonyfill.OPEN && !this.openPromise;
  }
  /**
  * Checks if the WebSocket connection is closed or in the process of closing.
  */
  isClosed() {
    return !!this.ws && (this.ws.readyState === this.WebSocketPonyfill.CLOSING || this.ws.readyState === this.WebSocketPonyfill.CLOSED);
  }
  async open() {
    var e = this;
    if (e.openPromise) return e.openPromise;
    e.id = ++Ze.connectCount;
    const r = Lr(e.urlOptions).then((n) => new e.WebSocketPonyfill(n));
    e.openPromise = r.then(async (n) => {
      e.ws = n, n.addEventListener("message", function({ data: s }) {
        s === "PING" && this.send("PONG");
      }), e.keepAliveOpts.enabled && Ur(n, e.keepAliveOpts), n.addEventListener("close", () => {
        e.ws === n && (e.ws = null);
      }), await Dr(n), e.urlOptions.connectionParams && n.send(await zr(e.urlOptions.connectionParams));
    });
    try {
      await e.openPromise;
    } finally {
      e.openPromise = null;
    }
  }
  /**
  * Closes the WebSocket connection gracefully.
  * Waits for any ongoing open operation to complete before closing.
  */
  async close() {
    var e = this;
    try {
      await e.openPromise;
    } finally {
      var r;
      (r = e.ws) === null || r === void 0 || r.close();
    }
  }
};
(0, W.default)(qr, "connectCount", 0);
P(J());
P(R());
var Re = P(J()), Ye = P(R()), Br = class {
  constructor(t) {
    (0, Re.default)(this, "links", void 0), (0, Re.default)(this, "runtime", void 0), (0, Re.default)(this, "requestId", void 0), this.requestId = 0, this.runtime = {}, this.links = t.links.map((e) => e(this.runtime));
  }
  $request(t) {
    var e;
    return lr({
      links: this.links,
      op: (0, Ye.default)((0, Ye.default)({}, t), {}, {
        context: (e = t.context) !== null && e !== void 0 ? e : {},
        id: ++this.requestId
      })
    }).pipe(cr());
  }
  async requestAsPromise(t) {
    var e = this;
    try {
      const r = e.$request(t);
      return (await or(r)).result.data;
    } catch (r) {
      throw xe.from(r);
    }
  }
  query(t, e, r) {
    return this.requestAsPromise({
      type: "query",
      path: t,
      input: e,
      context: r == null ? void 0 : r.context,
      signal: r == null ? void 0 : r.signal
    });
  }
  mutation(t, e, r) {
    return this.requestAsPromise({
      type: "mutation",
      path: t,
      input: e,
      context: r == null ? void 0 : r.context,
      signal: r == null ? void 0 : r.signal
    });
  }
  subscription(t, e, r) {
    return this.$request({
      type: "subscription",
      path: t,
      input: e,
      context: r.context,
      signal: r.signal
    }).subscribe({
      next(s) {
        switch (s.result.type) {
          case "state": {
            var i;
            (i = r.onConnectionStateChange) === null || i === void 0 || i.call(r, s.result);
            break;
          }
          case "started": {
            var a;
            (a = r.onStarted) === null || a === void 0 || a.call(r, { context: s.context });
            break;
          }
          case "stopped": {
            var o;
            (o = r.onStopped) === null || o === void 0 || o.call(r);
            break;
          }
          case "data":
          case void 0: {
            var c;
            (c = r.onData) === null || c === void 0 || c.call(r, s.result.data);
            break;
          }
        }
      },
      error(s) {
        var i;
        (i = r.onError) === null || i === void 0 || i.call(r, s);
      },
      complete() {
        var s;
        (s = r.onComplete) === null || s === void 0 || s.call(r);
      }
    });
  }
};
const Wr = Symbol.for("trpc_untypedClient"), Fr = {
  query: "query",
  mutate: "mutation",
  subscribe: "subscription"
}, Jr = (t) => Fr[t];
function Kr(t) {
  const e = yr(({ path: r, args: n }) => {
    const s = [...r], i = Jr(s.pop()), a = s.join(".");
    return t[i](a, ...n);
  });
  return vr((r) => r === Wr ? t : e[r]);
}
function Gr(t) {
  const e = new Br(t);
  return Kr(e);
}
P(R());
P(R());
var Hr = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/asyncIterator.js"(t, e) {
  function r(s) {
    var i, a, o, c = 2;
    for (typeof Symbol < "u" && (a = Symbol.asyncIterator, o = Symbol.iterator); c--; ) {
      if (a && (i = s[a]) != null) return i.call(s);
      if (o && (i = s[o]) != null) return new n(i.call(s));
      a = "@@asyncIterator", o = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
  }
  function n(s) {
    function i(a) {
      if (Object(a) !== a) return Promise.reject(new TypeError(a + " is not an object."));
      var o = a.done;
      return Promise.resolve(a.value).then(function(c) {
        return {
          value: c,
          done: o
        };
      });
    }
    return n = function(o) {
      this.s = o, this.n = o.next;
    }, n.prototype = {
      s: null,
      n: null,
      next: function() {
        return i(this.n.apply(this.s, arguments));
      },
      return: function(o) {
        var c = this.s.return;
        return c === void 0 ? Promise.resolve({
          value: o,
          done: !0
        }) : i(c.apply(this.s, arguments));
      },
      throw: function(o) {
        var c = this.s.return;
        return c === void 0 ? Promise.reject(o) : i(c.apply(this.s, arguments));
      }
    }, new n(s);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
} });
P(Hr());
P(R());
var Yr = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/usingCtx.js"(t, e) {
  function r() {
    var n = typeof SuppressedError == "function" ? SuppressedError : function(o, c) {
      var u = Error();
      return u.name = "SuppressedError", u.error = o, u.suppressed = c, u;
    }, s = {}, i = [];
    function a(o, c) {
      if (c != null) {
        if (Object(c) !== c) throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");
        if (o) var u = c[Symbol.asyncDispose || Symbol.for("Symbol.asyncDispose")];
        if (u === void 0 && (u = c[Symbol.dispose || Symbol.for("Symbol.dispose")], o)) var f = u;
        if (typeof u != "function") throw new TypeError("Object is not disposable.");
        f && (u = function() {
          try {
            f.call(c);
          } catch (b) {
            return Promise.reject(b);
          }
        }), i.push({
          v: c,
          d: u,
          a: o
        });
      } else o && i.push({
        d: c,
        a: o
      });
      return c;
    }
    return {
      e: s,
      u: a.bind(null, !1),
      a: a.bind(null, !0),
      d: function() {
        var c, u = this.e, f = 0;
        function m() {
          for (; c = i.pop(); ) try {
            if (!c.a && f === 1) return f = 0, i.push(c), Promise.resolve().then(m);
            if (c.d) {
              var g = c.d.call(c.v);
              if (c.a) return f |= 2, Promise.resolve(g).then(m, b);
            } else f |= 1;
          } catch (S) {
            return b(S);
          }
          if (f === 1) return u !== s ? Promise.reject(u) : Promise.resolve();
          if (u !== s) throw u;
        }
        function b(g) {
          return u = u !== s ? new n(g, u) : g, m();
        }
        return m();
      }
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), At = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/OverloadYield.js"(t, e) {
  function r(n, s) {
    this.v = n, this.k = s;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), Qr = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/awaitAsyncGenerator.js"(t, e) {
  var r = At();
  function n(s) {
    return new r(s, 0);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), Xr = Z({ "../../node_modules/.pnpm/@oxc-project+runtime@0.72.2/node_modules/@oxc-project/runtime/src/helpers/wrapAsyncGenerator.js"(t, e) {
  var r = At();
  function n(i) {
    return function() {
      return new s(i.apply(this, arguments));
    };
  }
  function s(i) {
    var a, o;
    function c(f, m) {
      try {
        var b = i[f](m), g = b.value, S = g instanceof r;
        Promise.resolve(S ? g.v : g).then(function(_) {
          if (S) {
            var j = f === "return" ? "return" : "next";
            if (!g.k || _.done) return c(j, _);
            _ = i[j](_).value;
          }
          u(b.done ? "return" : "normal", _);
        }, function(_) {
          c("throw", _);
        });
      } catch (_) {
        u("throw", _);
      }
    }
    function u(f, m) {
      switch (f) {
        case "return":
          a.resolve({
            value: m,
            done: !0
          });
          break;
        case "throw":
          a.reject(m);
          break;
        default:
          a.resolve({
            value: m,
            done: !1
          });
      }
      (a = a.next) ? c(a.key, a.arg) : o = null;
    }
    this._invoke = function(f, m) {
      return new Promise(function(b, g) {
        var S = {
          key: f,
          arg: m,
          resolve: b,
          reject: g,
          next: null
        };
        o ? o = o.next = S : (a = o = S, c(f, m));
      });
    }, typeof i.return != "function" && (this.return = void 0);
  }
  s.prototype[typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
  }, s.prototype.next = function(i) {
    return this._invoke("next", i);
  }, s.prototype.throw = function(i) {
    return this._invoke("throw", i);
  }, s.prototype.return = function(i) {
    return this._invoke("return", i);
  }, e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
} });
P(Yr());
P(Qr());
P(Xr());
P(R());
class en {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, r) {
    this.keyToValue.set(e, r), this.valueToKey.set(r, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}
class Ct {
  constructor(e) {
    this.generateIdentifier = e, this.kv = new en();
  }
  register(e, r) {
    this.kv.getByValue(e) || (r || (r = this.generateIdentifier(e)), this.kv.set(r, e));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(e) {
    return this.kv.getByValue(e);
  }
  getValue(e) {
    return this.kv.getByKey(e);
  }
}
class tn extends Ct {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, r) {
    typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(e, r.allowProps), super.register(e, r.identifier)) : super.register(e, r);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
}
function rn(t) {
  if ("values" in Object)
    return Object.values(t);
  const e = [];
  for (const r in t)
    t.hasOwnProperty(r) && e.push(t[r]);
  return e;
}
function nn(t, e) {
  const r = rn(t);
  if ("find" in r)
    return r.find(e);
  const n = r;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (e(i))
      return i;
  }
}
function Q(t, e) {
  Object.entries(t).forEach(([r, n]) => e(n, r));
}
function be(t, e) {
  return t.indexOf(e) !== -1;
}
function Qe(t, e) {
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (e(n))
      return n;
  }
}
class sn {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return nn(this.transfomers, (r) => r.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
}
const an = (t) => Object.prototype.toString.call(t).slice(8, -1), Rt = (t) => typeof t > "u", on = (t) => t === null, ue = (t) => typeof t != "object" || t === null || t === Object.prototype ? !1 : Object.getPrototypeOf(t) === null ? !0 : Object.getPrototypeOf(t) === Object.prototype, Me = (t) => ue(t) && Object.keys(t).length === 0, D = (t) => Array.isArray(t), cn = (t) => typeof t == "string", un = (t) => typeof t == "number" && !isNaN(t), ln = (t) => typeof t == "boolean", dn = (t) => t instanceof RegExp, le = (t) => t instanceof Map, de = (t) => t instanceof Set, It = (t) => an(t) === "Symbol", fn = (t) => t instanceof Date && !isNaN(t.valueOf()), hn = (t) => t instanceof Error, Xe = (t) => typeof t == "number" && isNaN(t), pn = (t) => ln(t) || on(t) || Rt(t) || un(t) || cn(t) || It(t), mn = (t) => typeof t == "bigint", yn = (t) => t === 1 / 0 || t === -1 / 0, vn = (t) => ArrayBuffer.isView(t) && !(t instanceof DataView), gn = (t) => t instanceof URL, Nt = (t) => t.replace(/\./g, "\\."), Ie = (t) => t.map(String).map(Nt).join("."), oe = (t) => {
  const e = [];
  let r = "";
  for (let s = 0; s < t.length; s++) {
    let i = t.charAt(s);
    if (i === "\\" && t.charAt(s + 1) === ".") {
      r += ".", s++;
      continue;
    }
    if (i === ".") {
      e.push(r), r = "";
      continue;
    }
    r += i;
  }
  const n = r;
  return e.push(n), e;
};
function I(t, e, r, n) {
  return {
    isApplicable: t,
    annotation: e,
    transform: r,
    untransform: n
  };
}
const Zt = [
  I(Rt, "undefined", () => null, () => {
  }),
  I(mn, "bigint", (t) => t.toString(), (t) => typeof BigInt < "u" ? BigInt(t) : (console.error("Please add a BigInt polyfill."), t)),
  I(fn, "Date", (t) => t.toISOString(), (t) => new Date(t)),
  I(hn, "Error", (t, e) => {
    const r = {
      name: t.name,
      message: t.message
    };
    return e.allowedErrorProps.forEach((n) => {
      r[n] = t[n];
    }), r;
  }, (t, e) => {
    const r = new Error(t.message);
    return r.name = t.name, r.stack = t.stack, e.allowedErrorProps.forEach((n) => {
      r[n] = t[n];
    }), r;
  }),
  I(dn, "regexp", (t) => "" + t, (t) => {
    const e = t.slice(1, t.lastIndexOf("/")), r = t.slice(t.lastIndexOf("/") + 1);
    return new RegExp(e, r);
  }),
  I(
    de,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (t) => [...t.values()],
    (t) => new Set(t)
  ),
  I(le, "map", (t) => [...t.entries()], (t) => new Map(t)),
  I((t) => Xe(t) || yn(t), "number", (t) => Xe(t) ? "NaN" : t > 0 ? "Infinity" : "-Infinity", Number),
  I((t) => t === 0 && 1 / t === -1 / 0, "number", () => "-0", Number),
  I(gn, "URL", (t) => t.toString(), (t) => new URL(t))
];
function Ae(t, e, r, n) {
  return {
    isApplicable: t,
    annotation: e,
    transform: r,
    untransform: n
  };
}
const Mt = Ae((t, e) => It(t) ? !!e.symbolRegistry.getIdentifier(t) : !1, (t, e) => ["symbol", e.symbolRegistry.getIdentifier(t)], (t) => t.description, (t, e, r) => {
  const n = r.symbolRegistry.getValue(e[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown symbol");
  return n;
}), _n = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((t, e) => (t[e.name] = e, t), {}), Vt = Ae(vn, (t) => ["typed-array", t.constructor.name], (t) => [...t], (t, e) => {
  const r = _n[e[1]];
  if (!r)
    throw new Error("Trying to deserialize unknown typed array");
  return new r(t);
});
function $t(t, e) {
  return t != null && t.constructor ? !!e.classRegistry.getIdentifier(t.constructor) : !1;
}
const Lt = Ae($t, (t, e) => ["class", e.classRegistry.getIdentifier(t.constructor)], (t, e) => {
  const r = e.classRegistry.getAllowedProps(t.constructor);
  if (!r)
    return { ...t };
  const n = {};
  return r.forEach((s) => {
    n[s] = t[s];
  }), n;
}, (t, e, r) => {
  const n = r.classRegistry.getValue(e[1]);
  if (!n)
    throw new Error(`Trying to deserialize unknown class '${e[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
  return Object.assign(Object.create(n.prototype), t);
}), zt = Ae((t, e) => !!e.customTransformerRegistry.findApplicable(t), (t, e) => ["custom", e.customTransformerRegistry.findApplicable(t).name], (t, e) => e.customTransformerRegistry.findApplicable(t).serialize(t), (t, e, r) => {
  const n = r.customTransformerRegistry.findByName(e[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown custom value");
  return n.deserialize(t);
}), bn = [Lt, Mt, zt, Vt], et = (t, e) => {
  const r = Qe(bn, (s) => s.isApplicable(t, e));
  if (r)
    return {
      value: r.transform(t, e),
      type: r.annotation(t, e)
    };
  const n = Qe(Zt, (s) => s.isApplicable(t, e));
  if (n)
    return {
      value: n.transform(t, e),
      type: n.annotation
    };
}, Dt = {};
Zt.forEach((t) => {
  Dt[t.annotation] = t;
});
const xn = (t, e, r) => {
  if (D(e))
    switch (e[0]) {
      case "symbol":
        return Mt.untransform(t, e, r);
      case "class":
        return Lt.untransform(t, e, r);
      case "custom":
        return zt.untransform(t, e, r);
      case "typed-array":
        return Vt.untransform(t, e, r);
      default:
        throw new Error("Unknown transformation: " + e);
    }
  else {
    const n = Dt[e];
    if (!n)
      throw new Error("Unknown transformation: " + e);
    return n.untransform(t, r);
  }
}, Y = (t, e) => {
  if (e > t.size)
    throw new Error("index out of bounds");
  const r = t.keys();
  for (; e > 0; )
    r.next(), e--;
  return r.next().value;
};
function Ut(t) {
  if (be(t, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (be(t, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (be(t, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
const wn = (t, e) => {
  Ut(e);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (de(t))
      t = Y(t, +n);
    else if (le(t)) {
      const s = +n, i = +e[++r] == 0 ? "key" : "value", a = Y(t, s);
      switch (i) {
        case "key":
          t = a;
          break;
        case "value":
          t = t.get(a);
          break;
      }
    } else
      t = t[n];
  }
  return t;
}, Ve = (t, e, r) => {
  if (Ut(e), e.length === 0)
    return r(t);
  let n = t;
  for (let i = 0; i < e.length - 1; i++) {
    const a = e[i];
    if (D(n)) {
      const o = +a;
      n = n[o];
    } else if (ue(n))
      n = n[a];
    else if (de(n)) {
      const o = +a;
      n = Y(n, o);
    } else if (le(n)) {
      if (i === e.length - 2)
        break;
      const c = +a, u = +e[++i] == 0 ? "key" : "value", f = Y(n, c);
      switch (u) {
        case "key":
          n = f;
          break;
        case "value":
          n = n.get(f);
          break;
      }
    }
  }
  const s = e[e.length - 1];
  if (D(n) ? n[+s] = r(n[+s]) : ue(n) && (n[s] = r(n[s])), de(n)) {
    const i = Y(n, +s), a = r(i);
    i !== a && (n.delete(i), n.add(a));
  }
  if (le(n)) {
    const i = +e[e.length - 2], a = Y(n, i);
    switch (+s == 0 ? "key" : "value") {
      case "key": {
        const c = r(a);
        n.set(c, n.get(a)), c !== a && n.delete(a);
        break;
      }
      case "value": {
        n.set(a, r(n.get(a)));
        break;
      }
    }
  }
  return t;
};
function $e(t, e, r = []) {
  if (!t)
    return;
  if (!D(t)) {
    Q(t, (i, a) => $e(i, e, [...r, ...oe(a)]));
    return;
  }
  const [n, s] = t;
  s && Q(s, (i, a) => {
    $e(i, e, [...r, ...oe(a)]);
  }), e(n, r);
}
function kn(t, e, r) {
  return $e(e, (n, s) => {
    t = Ve(t, s, (i) => xn(i, n, r));
  }), t;
}
function On(t, e) {
  function r(n, s) {
    const i = wn(t, oe(s));
    n.map(oe).forEach((a) => {
      t = Ve(t, a, () => i);
    });
  }
  if (D(e)) {
    const [n, s] = e;
    n.forEach((i) => {
      t = Ve(t, oe(i), () => t);
    }), s && Q(s, r);
  } else
    Q(e, r);
  return t;
}
const Sn = (t, e) => ue(t) || D(t) || le(t) || de(t) || $t(t, e);
function Pn(t, e, r) {
  const n = r.get(t);
  n ? n.push(e) : r.set(t, [e]);
}
function Tn(t, e) {
  const r = {};
  let n;
  return t.forEach((s) => {
    if (s.length <= 1)
      return;
    e || (s = s.map((o) => o.map(String)).sort((o, c) => o.length - c.length));
    const [i, ...a] = s;
    i.length === 0 ? n = a.map(Ie) : r[Ie(i)] = a.map(Ie);
  }), n ? Me(r) ? [n] : [n, r] : Me(r) ? void 0 : r;
}
const qt = (t, e, r, n, s = [], i = [], a = /* @__PURE__ */ new Map()) => {
  const o = pn(t);
  if (!o) {
    Pn(t, s, e);
    const g = a.get(t);
    if (g)
      return n ? {
        transformedValue: null
      } : g;
  }
  if (!Sn(t, r)) {
    const g = et(t, r), S = g ? {
      transformedValue: g.value,
      annotations: [g.type]
    } : {
      transformedValue: t
    };
    return o || a.set(t, S), S;
  }
  if (be(i, t))
    return {
      transformedValue: null
    };
  const c = et(t, r), u = (c == null ? void 0 : c.value) ?? t, f = D(u) ? [] : {}, m = {};
  Q(u, (g, S) => {
    if (S === "__proto__" || S === "constructor" || S === "prototype")
      throw new Error(`Detected property ${S}. This is a prototype pollution risk, please remove it from your object.`);
    const _ = qt(g, e, r, n, [...s, S], [...i, t], a);
    f[S] = _.transformedValue, D(_.annotations) ? m[S] = _.annotations : ue(_.annotations) && Q(_.annotations, (j, K) => {
      m[Nt(S) + "." + K] = j;
    });
  });
  const b = Me(m) ? {
    transformedValue: f,
    annotations: c ? [c.type] : void 0
  } : {
    transformedValue: f,
    annotations: c ? [c.type, m] : m
  };
  return o || a.set(t, b), b;
};
function Bt(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function tt(t) {
  return Bt(t) === "Array";
}
function jn(t) {
  if (Bt(t) !== "Object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return !!e && e.constructor === Object && e === Object.prototype;
}
function En(t, e, r, n, s) {
  const i = {}.propertyIsEnumerable.call(n, e) ? "enumerable" : "nonenumerable";
  i === "enumerable" && (t[e] = r), s && i === "nonenumerable" && Object.defineProperty(t, e, {
    value: r,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function Le(t, e = {}) {
  if (tt(t))
    return t.map((s) => Le(s, e));
  if (!jn(t))
    return t;
  const r = Object.getOwnPropertyNames(t), n = Object.getOwnPropertySymbols(t);
  return [...r, ...n].reduce((s, i) => {
    if (tt(e.props) && !e.props.includes(i))
      return s;
    const a = t[i], o = Le(a, e);
    return En(s, i, o, t, e.nonenumerable), s;
  }, {});
}
class w {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new tn(), this.symbolRegistry = new Ct((r) => r.description ?? ""), this.customTransformerRegistry = new sn(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const r = /* @__PURE__ */ new Map(), n = qt(e, r, this, this.dedupe), s = {
      json: n.transformedValue
    };
    n.annotations && (s.meta = {
      ...s.meta,
      values: n.annotations
    });
    const i = Tn(r, this.dedupe);
    return i && (s.meta = {
      ...s.meta,
      referentialEqualities: i
    }), s;
  }
  deserialize(e) {
    const { json: r, meta: n } = e;
    let s = Le(r);
    return n != null && n.values && (s = kn(s, n.values, this)), n != null && n.referentialEqualities && (s = On(s, n.referentialEqualities)), s;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e));
  }
  registerClass(e, r) {
    this.classRegistry.register(e, r);
  }
  registerSymbol(e, r) {
    this.symbolRegistry.register(e, r);
  }
  registerCustom(e, r) {
    this.customTransformerRegistry.register({
      name: r,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
}
w.defaultInstance = new w();
w.serialize = w.defaultInstance.serialize.bind(w.defaultInstance);
w.deserialize = w.defaultInstance.deserialize.bind(w.defaultInstance);
w.stringify = w.defaultInstance.stringify.bind(w.defaultInstance);
w.parse = w.defaultInstance.parse.bind(w.defaultInstance);
w.registerClass = w.defaultInstance.registerClass.bind(w.defaultInstance);
w.registerSymbol = w.defaultInstance.registerSymbol.bind(w.defaultInstance);
w.registerCustom = w.defaultInstance.registerCustom.bind(w.defaultInstance);
w.allowErrorProps = w.defaultInstance.allowErrorProps.bind(w.defaultInstance);
w.serialize;
w.deserialize;
w.stringify;
w.parse;
w.registerClass;
w.registerCustom;
w.registerSymbol;
w.allowErrorProps;
new TextEncoder();
const we = new TextDecoder();
function An(t) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(t);
  const e = atob(t), r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e.charCodeAt(n);
  return r;
}
function Wt(t) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof t == "string" ? t : we.decode(t), {
      alphabet: "base64url"
    });
  let e = t;
  e instanceof Uint8Array && (e = we.decode(e)), e = e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return An(e);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
class Ft extends Error {
  constructor(r, n) {
    var s;
    super(r, n);
    se(this, "code", "ERR_JOSE_GENERIC");
    this.name = this.constructor.name, (s = Error.captureStackTrace) == null || s.call(Error, this, this.constructor);
  }
}
se(Ft, "code", "ERR_JOSE_GENERIC");
class V extends Ft {
  constructor() {
    super(...arguments);
    se(this, "code", "ERR_JWT_INVALID");
  }
}
se(V, "code", "ERR_JWT_INVALID");
function Cn(t) {
  return typeof t == "object" && t !== null;
}
const Jt = (t) => {
  if (!Cn(t) || Object.prototype.toString.call(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
};
function Rn(t) {
  let e;
  if (typeof t == "string") {
    const r = t.split(".");
    (r.length === 3 || r.length === 5) && ([e] = r);
  } else if (typeof t == "object" && t)
    if ("protected" in t)
      e = t.protected;
    else
      throw new TypeError("Token does not contain a Protected Header");
  try {
    if (typeof e != "string" || !e)
      throw new Error();
    const r = JSON.parse(we.decode(Wt(e)));
    if (!Jt(r))
      throw new Error();
    return r;
  } catch {
    throw new TypeError("Invalid Token or Protected Header formatting");
  }
}
function In(t) {
  if (typeof t != "string")
    throw new V("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: e, length: r } = t.split(".");
  if (r === 5)
    throw new V("Only JWTs using Compact JWS serialization can be decoded");
  if (r !== 3)
    throw new V("Invalid JWT");
  if (!e)
    throw new V("JWTs must contain a payload");
  let n;
  try {
    n = Wt(e);
  } catch {
    throw new V("Failed to base64url decode the payload");
  }
  let s;
  try {
    s = JSON.parse(we.decode(n));
  } catch {
    throw new V("Failed to parse the decoded payload as JSON");
  }
  if (!Jt(s))
    throw new V("Invalid JWT Claims Set");
  return s;
}
var O;
(function(t) {
  t.assertEqual = (s) => {
  };
  function e(s) {
  }
  t.assertIs = e;
  function r(s) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (s) => {
    const i = {};
    for (const a of s)
      i[a] = a;
    return i;
  }, t.getValidEnumValues = (s) => {
    const i = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), a = {};
    for (const o of i)
      a[o] = s[o];
    return t.objectValues(a);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(i) {
    return s[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const a in s)
      Object.prototype.hasOwnProperty.call(s, a) && i.push(a);
    return i;
  }, t.find = (s, i) => {
    for (const a of s)
      if (i(a))
        return a;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function n(s, i = " | ") {
    return s.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})(O || (O = {}));
var rt;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(rt || (rt = {}));
const h = O.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), $ = (t) => {
  switch (typeof t) {
    case "undefined":
      return h.undefined;
    case "string":
      return h.string;
    case "number":
      return Number.isNaN(t) ? h.nan : h.number;
    case "boolean":
      return h.boolean;
    case "function":
      return h.function;
    case "bigint":
      return h.bigint;
    case "symbol":
      return h.symbol;
    case "object":
      return Array.isArray(t) ? h.array : t === null ? h.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? h.promise : typeof Map < "u" && t instanceof Map ? h.map : typeof Set < "u" && t instanceof Set ? h.set : typeof Date < "u" && t instanceof Date ? h.date : h.object;
    default:
      return h.unknown;
  }
}, l = O.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class M extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, s = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(s);
        else if (a.code === "invalid_return_type")
          s(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          s(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(r(a));
        else {
          let o = n, c = 0;
          for (; c < a.path.length; ) {
            const u = a.path[c];
            c === a.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(r(a))) : o[u] = o[u] || { _errors: [] }, o = o[u], c++;
          }
        }
    };
    return s(this), n;
  }
  static assert(e) {
    if (!(e instanceof M))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, O.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
M.create = (t) => new M(t);
const ze = (t, e) => {
  let r;
  switch (t.code) {
    case l.invalid_type:
      t.received === h.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case l.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, O.jsonStringifyReplacer)}`;
      break;
    case l.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${O.joinValues(t.keys, ", ")}`;
      break;
    case l.invalid_union:
      r = "Invalid input";
      break;
    case l.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${O.joinValues(t.options)}`;
      break;
    case l.invalid_enum_value:
      r = `Invalid enum value. Expected ${O.joinValues(t.options)}, received '${t.received}'`;
      break;
    case l.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case l.invalid_return_type:
      r = "Invalid function return type";
      break;
    case l.invalid_date:
      r = "Invalid date";
      break;
    case l.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : O.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case l.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case l.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case l.custom:
      r = "Invalid input";
      break;
    case l.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case l.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case l.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, O.assertNever(t);
  }
  return { message: r };
};
let Nn = ze;
function Zn() {
  return Nn;
}
const Mn = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: s } = t, i = [...r, ...s.path || []], a = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let o = "";
  const c = n.filter((u) => !!u).slice().reverse();
  for (const u of c)
    o = u(a, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: i,
    message: o
  };
};
function d(t, e) {
  const r = Zn(), n = Mn({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === ze ? void 0 : ze
      // then global default map
    ].filter((s) => !!s)
  });
  t.common.issues.push(n);
}
class E {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const s of r) {
      const i = await s.key, a = await s.value;
      n.push({
        key: i,
        value: a
      });
    }
    return E.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const s of r) {
      const { key: i, value: a } = s;
      if (i.status === "aborted" || a.status === "aborted")
        return y;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || s.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: e.value, value: n };
  }
}
const y = Object.freeze({
  status: "aborted"
}), ie = (t) => ({ status: "dirty", value: t }), A = (t) => ({ status: "valid", value: t }), nt = (t) => t.status === "aborted", st = (t) => t.status === "dirty", X = (t) => t.status === "valid", ke = (t) => typeof Promise < "u" && t instanceof Promise;
var p;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(p || (p = {}));
class U {
  constructor(e, r, n, s) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const it = (t, e) => {
  if (X(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new M(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function x(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: s } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (a, o) => {
    const { message: c } = t;
    return a.code === "invalid_enum_value" ? { message: c ?? o.defaultError } : typeof o.data > "u" ? { message: c ?? n ?? o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: c ?? r ?? o.defaultError };
  }, description: s };
}
class k {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return $(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: $(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new E(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: $(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (ke(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: $(e)
    }, s = this._parseSync({ data: e, path: n.path, parent: n });
    return it(n, s);
  }
  "~validate"(e) {
    var n, s;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: $(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: r });
        return X(i) ? {
          value: i.value
        } : {
          issues: r.common.issues
        };
      } catch (i) {
        (s = (n = i == null ? void 0 : i.message) == null ? void 0 : n.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: r }).then((i) => X(i) ? {
      value: i.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: $(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), i = await (ke(s) ? s : Promise.resolve(s));
    return it(n, i);
  }
  refine(e, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, i) => {
      const a = e(s), o = () => i.addIssue({
        code: l.custom,
        ...n(s)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(e) {
    return new re({
      schema: this,
      typeName: v.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return z.create(this, this._def);
  }
  nullable() {
    return ne.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return N.create(this);
  }
  promise() {
    return Te.create(this, this._def);
  }
  or(e) {
    return Se.create([this, e], this._def);
  }
  and(e) {
    return Pe.create(this, e, this._def);
  }
  transform(e) {
    return new re({
      ...x(this._def),
      schema: this,
      typeName: v.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ue({
      ...x(this._def),
      innerType: this,
      defaultValue: r,
      typeName: v.ZodDefault
    });
  }
  brand() {
    return new is({
      typeName: v.ZodBranded,
      type: this,
      ...x(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new qe({
      ...x(this._def),
      innerType: this,
      catchValue: r,
      typeName: v.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Fe.create(this, e);
  }
  readonly() {
    return Be.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Vn = /^c[^\s-]{8,}$/i, $n = /^[0-9a-z]+$/, Ln = /^[0-9A-HJKMNP-TV-Z]{26}$/i, zn = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Dn = /^[a-z0-9_-]{21}$/i, Un = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, qn = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Bn = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Wn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ne;
const Fn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Jn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Kn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Gn = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Hn = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Yn = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Kt = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Qn = new RegExp(`^${Kt}$`);
function Gt(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const r = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${r}`;
}
function Xn(t) {
  return new RegExp(`^${Gt(t)}$`);
}
function es(t) {
  let e = `${Kt}T${Gt(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function ts(t, e) {
  return !!((e === "v4" || !e) && Fn.test(t) || (e === "v6" || !e) && Kn.test(t));
}
function rs(t, e) {
  if (!Un.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), s = JSON.parse(atob(n));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function ns(t, e) {
  return !!((e === "v4" || !e) && Jn.test(t) || (e === "v6" || !e) && Gn.test(t));
}
class L extends k {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== h.string) {
      const i = this._getOrReturnCtx(e);
      return d(i, {
        code: l.invalid_type,
        expected: h.string,
        received: i.parsedType
      }), y;
    }
    const n = new E();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (s = this._getOrReturnCtx(e, s), d(s, {
          code: l.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (s = this._getOrReturnCtx(e, s), d(s, {
          code: l.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, o = e.data.length < i.value;
        (a || o) && (s = this._getOrReturnCtx(e, s), a ? d(s, {
          code: l.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && d(s, {
          code: l.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        Bn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "email",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        Ne || (Ne = new RegExp(Wn, "u")), Ne.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "emoji",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        zn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "uuid",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        Dn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "nanoid",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        Vn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "cuid",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        $n.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "cuid2",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        Ln.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
          validation: "ulid",
          code: l.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), d(s, {
            validation: "url",
            code: l.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "regex",
        code: l.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? es(i).test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? Qn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? Xn(i).test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? qn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "duration",
        code: l.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? ts(e.data, i.version) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "ip",
        code: l.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? rs(e.data, i.alg) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "jwt",
        code: l.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? ns(e.data, i.version) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "cidr",
        code: l.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? Hn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "base64",
        code: l.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? Yn.test(e.data) || (s = this._getOrReturnCtx(e, s), d(s, {
        validation: "base64url",
        code: l.invalid_string,
        message: i.message
      }), n.dirty()) : O.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((s) => e.test(s), {
      validation: r,
      code: l.invalid_string,
      ...p.errToObj(n)
    });
  }
  _addCheck(e) {
    return new L({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...p.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...p.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...p.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...p.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, p.errToObj(e));
  }
  trim() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new L({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
L.create = (t) => new L({
  checks: [],
  typeName: v.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...x(t)
});
function ss(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = r > n ? r : n, i = Number.parseInt(t.toFixed(s).replace(".", "")), a = Number.parseInt(e.toFixed(s).replace(".", ""));
  return i % a / 10 ** s;
}
class ee extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== h.number) {
      const i = this._getOrReturnCtx(e);
      return d(i, {
        code: l.invalid_type,
        expected: h.number,
        received: i.parsedType
      }), y;
    }
    let n;
    const s = new E();
    for (const i of this._def.checks)
      i.kind === "int" ? O.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? ss(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.not_finite,
        message: i.message
      }), s.dirty()) : O.assertNever(i);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, p.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, p.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, p.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, p.toString(r));
  }
  setLimit(e, r, n, s) {
    return new ee({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: p.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ee({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && O.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
ee.create = (t) => new ee({
  checks: [],
  typeName: v.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...x(t)
});
class fe extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== h.bigint)
      return this._getInvalidInput(e);
    let n;
    const s = new E();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), d(n, {
        code: l.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : O.assertNever(i);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return d(r, {
      code: l.invalid_type,
      expected: h.bigint,
      received: r.parsedType
    }), y;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, p.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, p.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, p.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, p.toString(r));
  }
  setLimit(e, r, n, s) {
    return new fe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: p.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new fe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
fe.create = (t) => new fe({
  checks: [],
  typeName: v.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...x(t)
});
class at extends k {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== h.boolean) {
      const n = this._getOrReturnCtx(e);
      return d(n, {
        code: l.invalid_type,
        expected: h.boolean,
        received: n.parsedType
      }), y;
    }
    return A(e.data);
  }
}
at.create = (t) => new at({
  typeName: v.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...x(t)
});
class Oe extends k {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== h.date) {
      const i = this._getOrReturnCtx(e);
      return d(i, {
        code: l.invalid_type,
        expected: h.date,
        received: i.parsedType
      }), y;
    }
    if (Number.isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return d(i, {
        code: l.invalid_date
      }), y;
    }
    const n = new E();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (s = this._getOrReturnCtx(e, s), d(s, {
        code: l.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : O.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
Oe.create = (t) => new Oe({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: v.ZodDate,
  ...x(t)
});
class ot extends k {
  _parse(e) {
    if (this._getType(e) !== h.symbol) {
      const n = this._getOrReturnCtx(e);
      return d(n, {
        code: l.invalid_type,
        expected: h.symbol,
        received: n.parsedType
      }), y;
    }
    return A(e.data);
  }
}
ot.create = (t) => new ot({
  typeName: v.ZodSymbol,
  ...x(t)
});
class ct extends k {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const n = this._getOrReturnCtx(e);
      return d(n, {
        code: l.invalid_type,
        expected: h.undefined,
        received: n.parsedType
      }), y;
    }
    return A(e.data);
  }
}
ct.create = (t) => new ct({
  typeName: v.ZodUndefined,
  ...x(t)
});
class ut extends k {
  _parse(e) {
    if (this._getType(e) !== h.null) {
      const n = this._getOrReturnCtx(e);
      return d(n, {
        code: l.invalid_type,
        expected: h.null,
        received: n.parsedType
      }), y;
    }
    return A(e.data);
  }
}
ut.create = (t) => new ut({
  typeName: v.ZodNull,
  ...x(t)
});
class lt extends k {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return A(e.data);
  }
}
lt.create = (t) => new lt({
  typeName: v.ZodAny,
  ...x(t)
});
class dt extends k {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return A(e.data);
  }
}
dt.create = (t) => new dt({
  typeName: v.ZodUnknown,
  ...x(t)
});
class q extends k {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return d(r, {
      code: l.invalid_type,
      expected: h.never,
      received: r.parsedType
    }), y;
  }
}
q.create = (t) => new q({
  typeName: v.ZodNever,
  ...x(t)
});
class ft extends k {
  _parse(e) {
    if (this._getType(e) !== h.undefined) {
      const n = this._getOrReturnCtx(e);
      return d(n, {
        code: l.invalid_type,
        expected: h.void,
        received: n.parsedType
      }), y;
    }
    return A(e.data);
  }
}
ft.create = (t) => new ft({
  typeName: v.ZodVoid,
  ...x(t)
});
class N extends k {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), s = this._def;
    if (r.parsedType !== h.array)
      return d(r, {
        code: l.invalid_type,
        expected: h.array,
        received: r.parsedType
      }), y;
    if (s.exactLength !== null) {
      const a = r.data.length > s.exactLength.value, o = r.data.length < s.exactLength.value;
      (a || o) && (d(r, {
        code: a ? l.too_big : l.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: a ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (d(r, {
      code: l.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (d(r, {
      code: l.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((a, o) => s.type._parseAsync(new U(r, a, r.path, o)))).then((a) => E.mergeArray(n, a));
    const i = [...r.data].map((a, o) => s.type._parseSync(new U(r, a, r.path, o)));
    return E.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new N({
      ...this._def,
      minLength: { value: e, message: p.toString(r) }
    });
  }
  max(e, r) {
    return new N({
      ...this._def,
      maxLength: { value: e, message: p.toString(r) }
    });
  }
  length(e, r) {
    return new N({
      ...this._def,
      exactLength: { value: e, message: p.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
N.create = (t, e) => new N({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: v.ZodArray,
  ...x(e)
});
function H(t) {
  if (t instanceof T) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = z.create(H(n));
    }
    return new T({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof N ? new N({
    ...t._def,
    type: H(t.element)
  }) : t instanceof z ? z.create(H(t.unwrap())) : t instanceof ne ? ne.create(H(t.unwrap())) : t instanceof F ? F.create(t.items.map((e) => H(e))) : t;
}
class T extends k {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = O.objectKeys(e);
    return this._cached = { shape: e, keys: r }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== h.object) {
      const u = this._getOrReturnCtx(e);
      return d(u, {
        code: l.invalid_type,
        expected: h.object,
        received: u.parsedType
      }), y;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof q && this._def.unknownKeys === "strip"))
      for (const u in s.data)
        a.includes(u) || o.push(u);
    const c = [];
    for (const u of a) {
      const f = i[u], m = s.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: f._parse(new U(s, m, s.path, u)),
        alwaysSet: u in s.data
      });
    }
    if (this._def.catchall instanceof q) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const f of o)
          c.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: s.data[f] }
          });
      else if (u === "strict")
        o.length > 0 && (d(s, {
          code: l.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const f of o) {
        const m = s.data[f];
        c.push({
          key: { status: "valid", value: f },
          value: u._parse(
            new U(s, m, s.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const f of c) {
        const m = await f.key, b = await f.value;
        u.push({
          key: m,
          value: b,
          alwaysSet: f.alwaysSet
        });
      }
      return u;
    }).then((u) => E.mergeObjectSync(n, u)) : E.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p.errToObj, new T({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var i, a;
          const s = ((a = (i = this._def).errorMap) == null ? void 0 : a.call(i, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: p.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new T({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new T({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new T({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new T({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: v.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new T({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    for (const n of O.objectKeys(e))
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new T({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    for (const n of O.objectKeys(this.shape))
      e[n] || (r[n] = this.shape[n]);
    return new T({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return H(this);
  }
  partial(e) {
    const r = {};
    for (const n of O.objectKeys(this.shape)) {
      const s = this.shape[n];
      e && !e[n] ? r[n] = s : r[n] = s.optional();
    }
    return new T({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    for (const n of O.objectKeys(this.shape))
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof z; )
          i = i._def.innerType;
        r[n] = i;
      }
    return new T({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Ht(O.objectKeys(this.shape));
  }
}
T.create = (t, e) => new T({
  shape: () => t,
  unknownKeys: "strip",
  catchall: q.create(),
  typeName: v.ZodObject,
  ...x(e)
});
T.strictCreate = (t, e) => new T({
  shape: () => t,
  unknownKeys: "strict",
  catchall: q.create(),
  typeName: v.ZodObject,
  ...x(e)
});
T.lazycreate = (t, e) => new T({
  shape: t,
  unknownKeys: "strip",
  catchall: q.create(),
  typeName: v.ZodObject,
  ...x(e)
});
class Se extends k {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function s(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const a = i.map((o) => new M(o.ctx.common.issues));
      return d(r, {
        code: l.invalid_union,
        unionErrors: a
      }), y;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: a
          }),
          ctx: a
        };
      })).then(s);
    {
      let i;
      const a = [];
      for (const c of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, f = c._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: u }), u.common.issues.length && a.push(u.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((c) => new M(c));
      return d(r, {
        code: l.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
Se.create = (t, e) => new Se({
  options: t,
  typeName: v.ZodUnion,
  ...x(e)
});
function De(t, e) {
  const r = $(t), n = $(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === h.object && n === h.object) {
    const s = O.objectKeys(e), i = O.objectKeys(t).filter((o) => s.indexOf(o) !== -1), a = { ...t, ...e };
    for (const o of i) {
      const c = De(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      a[o] = c.data;
    }
    return { valid: !0, data: a };
  } else if (r === h.array && n === h.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const a = t[i], o = e[i], c = De(a, o);
      if (!c.valid)
        return { valid: !1 };
      s.push(c.data);
    }
    return { valid: !0, data: s };
  } else return r === h.date && n === h.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Pe extends k {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = (i, a) => {
      if (nt(i) || nt(a))
        return y;
      const o = De(i.value, a.value);
      return o.valid ? ((st(i) || st(a)) && r.dirty(), { status: r.value, value: o.data }) : (d(n, {
        code: l.invalid_intersection_types
      }), y);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => s(i, a)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Pe.create = (t, e, r) => new Pe({
  left: t,
  right: e,
  typeName: v.ZodIntersection,
  ...x(r)
});
class F extends k {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.array)
      return d(n, {
        code: l.invalid_type,
        expected: h.array,
        received: n.parsedType
      }), y;
    if (n.data.length < this._def.items.length)
      return d(n, {
        code: l.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && n.data.length > this._def.items.length && (d(n, {
      code: l.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((a, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new U(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => E.mergeArray(r, a)) : E.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new F({
      ...this._def,
      rest: e
    });
  }
}
F.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new F({
    items: t,
    typeName: v.ZodTuple,
    rest: null,
    ...x(e)
  });
};
class ht extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.map)
      return d(n, {
        code: l.invalid_type,
        expected: h.map,
        received: n.parsedType
      }), y;
    const s = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([o, c], u) => ({
      key: s._parse(new U(n, o, n.path, [u, "key"])),
      value: i._parse(new U(n, c, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const u = await c.key, f = await c.value;
          if (u.status === "aborted" || f.status === "aborted")
            return y;
          (u.status === "dirty" || f.status === "dirty") && r.dirty(), o.set(u.value, f.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of a) {
        const u = c.key, f = c.value;
        if (u.status === "aborted" || f.status === "aborted")
          return y;
        (u.status === "dirty" || f.status === "dirty") && r.dirty(), o.set(u.value, f.value);
      }
      return { status: r.value, value: o };
    }
  }
}
ht.create = (t, e, r) => new ht({
  valueType: e,
  keyType: t,
  typeName: v.ZodMap,
  ...x(r)
});
class he extends k {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== h.set)
      return d(n, {
        code: l.invalid_type,
        expected: h.set,
        received: n.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (d(n, {
      code: l.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (d(n, {
      code: l.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function a(c) {
      const u = /* @__PURE__ */ new Set();
      for (const f of c) {
        if (f.status === "aborted")
          return y;
        f.status === "dirty" && r.dirty(), u.add(f.value);
      }
      return { status: r.value, value: u };
    }
    const o = [...n.data.values()].map((c, u) => i._parse(new U(n, c, n.path, u)));
    return n.common.async ? Promise.all(o).then((c) => a(c)) : a(o);
  }
  min(e, r) {
    return new he({
      ...this._def,
      minSize: { value: e, message: p.toString(r) }
    });
  }
  max(e, r) {
    return new he({
      ...this._def,
      maxSize: { value: e, message: p.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
he.create = (t, e) => new he({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: v.ZodSet,
  ...x(e)
});
class pt extends k {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
pt.create = (t, e) => new pt({
  getter: t,
  typeName: v.ZodLazy,
  ...x(e)
});
class mt extends k {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return d(r, {
        received: r.data,
        code: l.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
mt.create = (t, e) => new mt({
  value: t,
  typeName: v.ZodLiteral,
  ...x(e)
});
function Ht(t, e) {
  return new te({
    values: t,
    typeName: v.ZodEnum,
    ...x(e)
  });
}
class te extends k {
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return d(r, {
        expected: O.joinValues(n),
        received: r.parsedType,
        code: l.invalid_type
      }), y;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return d(r, {
        received: r.data,
        code: l.invalid_enum_value,
        options: n
      }), y;
    }
    return A(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return te.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return te.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
te.create = Ht;
class yt extends k {
  _parse(e) {
    const r = O.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== h.string && n.parsedType !== h.number) {
      const s = O.objectValues(r);
      return d(n, {
        expected: O.joinValues(s),
        received: n.parsedType,
        code: l.invalid_type
      }), y;
    }
    if (this._cache || (this._cache = new Set(O.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = O.objectValues(r);
      return d(n, {
        received: n.data,
        code: l.invalid_enum_value,
        options: s
      }), y;
    }
    return A(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
yt.create = (t, e) => new yt({
  values: t,
  typeName: v.ZodNativeEnum,
  ...x(e)
});
class Te extends k {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== h.promise && r.common.async === !1)
      return d(r, {
        code: l.invalid_type,
        expected: h.promise,
        received: r.parsedType
      }), y;
    const n = r.parsedType === h.promise ? r.data : Promise.resolve(r.data);
    return A(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
Te.create = (t, e) => new Te({
  type: t,
  typeName: v.ZodPromise,
  ...x(e)
});
class re extends k {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === v.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = this._def.effect || null, i = {
      addIssue: (a) => {
        d(n, a), a.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const a = s.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (r.value === "aborted")
            return y;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? y : c.status === "dirty" || r.value === "dirty" ? ie(c.value) : c;
        });
      {
        if (r.value === "aborted")
          return y;
        const o = this._def.schema._parseSync({
          data: a,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : o.status === "dirty" || r.value === "dirty" ? ie(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const a = (o) => {
        const c = s.refinement(o, i);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), a(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), a(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!X(a))
          return y;
        const o = s.transform(a.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => X(a) ? Promise.resolve(s.transform(a.value, i)).then((o) => ({
          status: r.value,
          value: o
        })) : y);
    O.assertNever(s);
  }
}
re.create = (t, e, r) => new re({
  schema: t,
  typeName: v.ZodEffects,
  effect: e,
  ...x(r)
});
re.createWithPreprocess = (t, e, r) => new re({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: v.ZodEffects,
  ...x(r)
});
class z extends k {
  _parse(e) {
    return this._getType(e) === h.undefined ? A(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
z.create = (t, e) => new z({
  innerType: t,
  typeName: v.ZodOptional,
  ...x(e)
});
class ne extends k {
  _parse(e) {
    return this._getType(e) === h.null ? A(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ne.create = (t, e) => new ne({
  innerType: t,
  typeName: v.ZodNullable,
  ...x(e)
});
class Ue extends k {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === h.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ue.create = (t, e) => new Ue({
  innerType: t,
  typeName: v.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...x(e)
});
class qe extends k {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return ke(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new M(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new M(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
qe.create = (t, e) => new qe({
  innerType: t,
  typeName: v.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...x(e)
});
class vt extends k {
  _parse(e) {
    if (this._getType(e) !== h.nan) {
      const n = this._getOrReturnCtx(e);
      return d(n, {
        code: l.invalid_type,
        expected: h.nan,
        received: n.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
vt.create = (t) => new vt({
  typeName: v.ZodNaN,
  ...x(t)
});
class is extends k {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Fe extends k {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? y : i.status === "dirty" ? (r.dirty(), ie(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new Fe({
      in: e,
      out: r,
      typeName: v.ZodPipeline
    });
  }
}
class Be extends k {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (s) => (X(s) && (s.value = Object.freeze(s.value)), s);
    return ke(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Be.create = (t, e) => new Be({
  innerType: t,
  typeName: v.ZodReadonly,
  ...x(e)
});
var v;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(v || (v = {}));
const B = L.create, as = ee.create;
q.create;
N.create;
const me = T.create;
Se.create;
Pe.create;
F.create;
const os = te.create;
Te.create;
z.create;
ne.create;
const cs = me({
  user_id: B()
}), us = me({
  prospective_user_id: B()
});
me({
  wintrix_user_id: as(),
  prospective_user_id: B().optional(),
  nonce: B()
});
me({
  user_id: B(),
  nonce: B()
});
me({
  type: os(["auth", "auth_prospect"]),
  user_id: B(),
  nonce: B()
});
function ds(t) {
  const { typ: e } = Rn(t), r = In(t);
  switch (e) {
    case "auth":
      return { type: "auth", ...cs.parse(r) };
    case "auth_prospect":
      return { type: "auth_prospect", ...us.parse(r) };
  }
}
function fs(t, e) {
  const r = new URL("/api/trpc", t).toString();
  return Gr({
    links: [
      Vr({
        transformer: w,
        url: r,
        headers() {
          return e ? {
            authorization: `Bearer ${e}`
          } : {};
        }
      })
    ]
  });
}
export {
  fs as createClient,
  ds as extractToken
};
